export default __webpack_public_path__ + "static/media/la-brands-400.925b340f.woff";